import { render, staticRenderFns } from "./JssAuthenticationSitecore.vue?vue&type=template&id=c6b63f4e"
import script from "./JssAuthenticationSitecore.vue?vue&type=script&lang=js"
export * from "./JssAuthenticationSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports